import { formatUserName } from '../../utils/utils';
import LiveKitModalClose from '../LiveKitModalClose';
import LiveKitPrimaryButton from '../LiveKitPrimaryButton';

import { Icon } from '@amigoapp/doca-react';

const AI_POINTS = [{
	icon: 'user-doctor',
	text: 'A IA é apenas apoio. Quem revisa, decide e assina é o profissional.'
}, {
	icon: 'lock',
	text: 'O áudio é usado apenas para preparar os registros desta consulta e tratado com sigilo conforme a Lei Geral de Proteção de Dados.'
}, {
	icon: 'hand',
	text: 'Você pode recusar agora ou pedir a interrupção a qualquer momento, sem prejuízo ao atendimento.'
}];

const LiveKitAiConsentModal = ({ loading, provider, onAccept, onClose, onDecline }) => (
	<div className="lk-modal-overlay lk-modal-overlay--fixed">
		<div className="lk-modal lk-modal--compact">
			<div className="lk-modal__head">
				<div className="lk-ai__heading">
					<div className="lk-ai__badge">
						<Icon name="sparkle" type="solid" />
					</div>
					<h3 className="lk-attach__title lk-ai__title">Uso de IA na consulta</h3>
				</div>
				<LiveKitModalClose onClick={onClose} />
			</div>

			<p className="lk-attach__subtitle lk-ai__subtitle">
				Ao aceitar, você autoriza {formatUserName(provider.title, provider.name)} a usar recursos
				de inteligência artificial que ouve a teleconsulta para preparar rascunhos dos registros
				no seu prontuário.
			</p>

			<ul className="lk-ai__points">
				{AI_POINTS.map(point => (
					<li key={point.icon} className="lk-ai__point">
						<Icon className="lk-ai__point-icon" name={point.icon} type="regular" />
						<span>{point.text}</span>
					</li>
				))}
			</ul>

			<div className="lk-attach__actions">
				<LiveKitPrimaryButton loading={loading} onClick={onAccept}>
					Aceito o uso de IA
				</LiveKitPrimaryButton>
				<button className="lk-secondary-btn lk-ai__decline" disabled={loading} type="button" onClick={onDecline}>
					Não aceito
				</button>
			</div>
		</div>
	</div>
);

export default LiveKitAiConsentModal;
